var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('span',{class:`material-icons${_vm.materialIconsStyleClass}`,attrs:{"translate":"no"}},[_vm._v(_vm._s(_vm.icon))]):(_vm.symbol)?_c('span',{staticClass:"material-symbols-outlined",attrs:{"translate":"no"}},[_vm._v(" "+_vm._s(_vm.symbol)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }